import * as types from './actionTypes';
import { branchService } from '../_services';

export function fetchBranchList() {
  return dispatch => {
    return branchService
      .getAllBranch()
      .then(payload => {
        dispatch(success(payload));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function success(payload) {
    return { type: types.FETCH_BRANCHLIST, payload: payload };
  }
  function failure(error) {
    return { type: types.FETCH_BRANCHLIST_FAILURE, error };
  }
}
